import type { RouteKind } from '../route-kind'
import type { RouteDefinition } from './route-definition'

export interface AppRouteRouteDefinition
  extends RouteDefinition<RouteKind.APP_ROUTE> {}
